import apiClient from '.';

const createMappings = async (params: Record<string, any>) => {
    try {
        const { data }: any = await apiClient.post('tableau-details', {
            data: params,
        });
        if (data.error) {
            return {
                error: data?.error,
            };
        }
        return data;
    } catch (e: any) {
        return {
            state: 'error',
            message: e.message,
        };
    }
};

const updateMappings = async (params: Record<string, any>) => {
    try {
        const { data }: any = await apiClient.post('tableau-details', {
            data: params,
        });
        if (data.error) {
            return {
                error: data?.error,
            };
        }
        return data;
    } catch (e: any) {
        return { state: 'error', message: e.message };
    }
};

export { createMappings, updateMappings };
